import { z } from 'zod';
import { isDefined } from '../typeUtils/index.js';
/**
 * An enum field that may be omitted from the input but always parses to a value.
 * The inferred key stays optional so callers can leave it out when constructing an instance.
 */
export function OptionalEnumSchema(nativeEnum, defaultValue) {
    // Parsing always yields a defined value; the cast presents the schema as a ZodOptional
    // so the inferred key stays optional (callers may omit it).
    return z.enum(nativeEnum).optional().default(defaultValue);
}
/** A field accepting either a single `schema` value or an array of them. */
export function OneOrManySchema(schema, options) {
    const { arrayMax } = options ?? {};
    let arraySchema = z.array(schema);
    if (isDefined(arrayMax)) {
        arraySchema = arraySchema.max(arrayMax);
    }
    return z.union([schema, arraySchema]);
}
const QUERY_BOOLEAN_WORDS = ['true', 'false', '1', '0', ''];
/**
 * A boolean as it arrives in a query string, where it is a word rather than a value.
 *
 * `z.coerce.boolean()` is the obvious thing to reach for and is wrong here: it applies JavaScript
 * truthiness, under which `'false'` and `'0'` are both `true`, so a caller asking to exclude
 * something gets everything included instead.
 *
 * An empty value is false, because `qs.stringify` writes a null property that way and a client
 * that does so means the flag off.
 */
export const QueryBooleanSchema = z
    .union([
    z.boolean(),
    z
        .string()
        // The published input is the string before normalization, so name the words it accepts.
        .meta({ enum: [...QUERY_BOOLEAN_WORDS] })
        .transform((value) => value.trim().toLowerCase())
        .pipe(z.enum(QUERY_BOOLEAN_WORDS)),
])
    .transform((value) => value === true || value === 'true' || value === '1')
    .describe('true, false, 1, 0 or empty, in any case.');
//# sourceMappingURL=utils.js.map